import styled from '@emotion/styled'
import { css } from '@emotion/core'

export const PopupContent = styled('div')(css`
  margin-left: -24px;
  margin-right: -18px;
`)
